export const CSRF_COOKIE = "lms_csrf";
export const CSRF_HEADER = "x-csrf-token";
